module.exports = __webpack_public_path__ + "img/francesco.175d20ac.png";